import React from 'react'
import { SPACING } from '@fedsim/constants'
import { Stack } from '@mui/material'

import { HeaderTertiary } from '../../typography'
import { ImageBlock } from '../../image-block'

const minWidth = 200

export const GenericItem = props => {
  const {
    children = null,
    color = '',
    backgroundColor = '',
    name = '',
    image = '',
    StackComponent = Stack
  } = props
  return (
    <>
      <Stack
        spacing={SPACING}
        sx={{
          color,
          minWidth,
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row-reverse",
          flexWrap: {
            xs: "nowrap",
            sm: "nowrap",
            md: "wrap"
          }
        }}>
        {image ? <ImageBlock image={image} backgroundColor={backgroundColor} /> : <div />}
        <Stack direction='column' spacing={SPACING} mb={1}>
          <HeaderTertiary>{name}</HeaderTertiary>
          <StackComponent {...props} />
        </Stack>
      </Stack>
      {children}
    </>
  )
}
